import styles from './ApplyButton.module.css'
import classNames from 'classnames'
import CheckIcon from '@mui/icons-material/Check'

interface ApplyButtonProps {
    className?: string
    onClick?: (event: any) => void
}

export const ApplyButton = (props: ApplyButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const applyButtonClasses = classNames(styles.ApplyButton, className)

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={applyButtonClasses}
            onClick={handleButtonClick}>
            <span className={styles.ApplyButton__IconContainer}>
                <CheckIcon className={styles.ApplyButton__Icon}  />
            </span>

            <span className={styles.ApplyButton__Caption}>
                Apply
            </span>            
        </button>
    )
}